function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_105",
  "data-name": "Grupo 105",
  transform: "translate(-620.775 -119.135)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_92",
  "data-name": "Caminho 92",
  d: "M645.788,119.135a25,25,0,1,1-25.013,24.943A24.995,24.995,0,0,1,645.788,119.135Zm-.03,4.366a20.639,20.639,0,1,0,20.631,20.469A20.625,20.625,0,0,0,645.758,123.5Z",
  transform: "translate(0 0)",
  fill: "#949ca3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_93",
  "data-name": "Caminho 93",
  d: "M803.368,266.545l5.971,6.465q1.288,1.394,2.576,2.787a2.182,2.182,0,1,1-3.18,2.983q-4.719-5.091-9.417-10.2a5.292,5.292,0,0,1-.841-1.078,2.114,2.114,0,0,1,.432-2.58q4.888-5.3,9.786-10.591a2.189,2.189,0,0,1,3.183-.194,2.213,2.213,0,0,1-.013,3.193q-4.079,4.405-8.153,8.816C803.6,266.263,803.5,266.389,803.368,266.545Z",
  transform: "translate(-161.588 -122.399)",
  fill: "#949ca3"
}));

var SvgArrowBack = function SvgArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.975,
    height: 50,
    viewBox: "0 0 49.975 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Arrow-back.5b1d47a2.svg";
export { ForwardRef as ReactComponent };